import { Input } from '@mui/material';
import styled from 'styled-components';
import { colors, fontFamilyPrimary, fontSize, fontWeight } from '../../../../theme';

export const StatusEditorContainer = styled.div`
    margin-top: 24px;
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const StatusRowContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    overflow-y: auto;
    max-height: 240px;
    padding-right: 10px;

    &::-webkit-scrollbar {
        -webkit-appearance: none;
        width: 7px;
    }

    &::-webkit-scrollbar-thumb {
        border-radius: 4px;
        background-color: ${colors.grey600};
    }
`;

export const StatusEditorHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 4px;
`;

export const StatusRow = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    background-color: ${colors.grey000};
    border: 1px solid ${colors.grey500};
    border-radius: 8px;
    padding: 10px 12px;
`;

export const StatusRowFields = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
    flex: 1;
    flex-wrap: wrap;
`;

export const StatusRowActions = styled.div`
    flex-shrink: 0;
`;

export const StatusInputStyled = styled(Input)`
    && {
        font-family: ${fontFamilyPrimary};
        font-size: ${fontSize.sm};
        color: ${colors.grey100};
        min-width: 160px;
        max-width: 400px;
        width: 30%;
        &::before { border-bottom: 1px solid ${colors.grey500}; }
        &::after { border-bottom: 1px solid ${colors.default}; }
        &:hover:not(.Mui-disabled):before { border-bottom: 1px solid ${colors.grey300}; }
    }
`;

export const StatusFieldLabel = styled.span`
    font-family: ${fontFamilyPrimary};
    font-size: ${fontSize.s};
    font-weight: ${fontWeight.regular};
    color: ${colors.grey300};
    white-space: nowrap;
`;

export const StatusRadioGroup = styled.label`
    display: flex;
    align-items: center;
    gap: 6px;
    cursor: pointer;
`;

export const StatusRadioButton = styled.input`
    accent-color: ${colors.default};
    cursor: pointer;
    width: 16px;
    height: 16px;
`;

export const StatusColorWrapper = styled.label`
    display: flex;
    align-items: center;
    gap: 6px;
    cursor: pointer;
`;

export const StatusColorPreview = styled.div`
    width: 28px;
    height: 28px;
    border-radius: 6px;
    border: 1px solid ${colors.grey500};
    overflow: hidden;
    cursor: pointer;
    position: relative;
    flex-shrink: 0;

    input[type='color'] {
        position: absolute;
        inset: 0;
        width: 100%;
        height: 100%;
        opacity: 0;
        cursor: pointer;
        border: none;
        padding: 0;
    }
`;

export const DragHandleStyled = styled.div`
    cursor: grab;
    display: flex;
    align-items: center;
    flex-shrink: 0;
    &:active {
        cursor: grabbing;
    }
`;

export const StatusHexInput = styled.input`
    font-family: ${fontFamilyPrimary};
    font-size: ${fontSize.s};
    color: ${colors.grey100};
    background: transparent;
    border: none;
    border-bottom: 1px solid ${colors.grey500};
    width: 72px;
    padding: 2px 0;
    outline: none;
    letter-spacing: 0.5px;

    &:focus {
        border-bottom-color: ${colors.default};
    }
`;
